define('views/ui/ProductLineView',['backbone','jquery','app','SubView','views/pages/ProductPageView',
        'TagCommander',
        'template!blocks/product-line','SelectView'],
    function (Backbone, $, app, SubView, ProductPageView,
              TagCommander,
              ProductLineTemplate, SelectView) {

    //
    // ProductLine View
    //

    var sidedishIdPattern = /^sidedish_(.*)_(.*)$/;

    function eventPreventDefaultStopPropagation(e){
        if(e){
            e.preventDefault();
            e.stopPropagation();
        }
    }

    var ProductLineView = Backbone.View.extend(SubView).extend({

        events:{
            'click .btn-delete':'deleteProduct',
            'click .btn-quantity':'updateQuantityProduct',
            //'click .name, .product-sidedish .accompagnement, .main-info, .illus, .price':'simpleClick',
            'click':'simpleClick',
        },
        initialize:function(options){

            var view = this,id_cart_product,cartProduct,dataAttr=view.$el.data();
            // SubViews
            view.subviews = [];
            options = _.defaults(options,dataAttr,{});
            view.format = options.format || 'mini';
            view.editable = !!options.editable;

            if(options.cartProduct){
                cartProduct = options.cartProduct;
                id_cart_product = cartProduct.id;
            }else{
                id_cart_product = dataAttr.id_cart_product.toString();
                if (/^extraPrice_/.test(id_cart_product))
                {
                    return ;
                }
                cartProduct = app.getCartProduct(id_cart_product);
            }
            view.id_cart_product = id_cart_product;
            view.cartProduct = cartProduct;

            view.listenTo(cartProduct,'change',view.onChange);
            view.listenTo(cartProduct,'remove delete',view.onRemove);
            view.listenTo(app,'alertRequiredSidedishes',view.alertRequiredSidedishes);
            //
            if(!options.el){
                view.render();
            } else {
                view.delegateEvents();
            }
            view.attachViews(SelectView.initializeSelectsOfView(this));
        },
        render:function(){
            var view = this;
            view.setElement($(ProductLineTemplate({
                product: view.cartProduct,
                format: view.format,
                editable: view.editable
            })).get(0));
            view.delegateEvents();
            return view;
        },
        updateFreeProduct:function(){
            app.getCart().reopenFreeProductChoice();
        },
        onChange:function(){
            var view = this,
                cartProduct = view.cartProduct,
                changed = cartProduct.changed,
                priceValue = view.$('.price .value'),
                isProductLikeOffered = cartProduct.isProductLikeOffered();
            //
            view.$('.quantity').text(cartProduct.displayQuantity());
            view.$('.quantity-bloc').attr('data-q',cartProduct.getQuantity());
            view.$('.quantity-bloc button').attr('disabled',false);
            view.$('.circle-loader.playing').removeClass('playing');
            if(!isProductLikeOffered && !!cartProduct.getPrice()){
                priceValue.text(cartProduct.formatPrice());
            }
            if(changed && changed.accompagnements){
                view.$('.accompagnements').html(cartProduct.formatAccompagnements());
            }
        },
        onRemove:function(){
            this.remove();
        },
        deleteProduct:function(e){
            eventPreventDefaultStopPropagation(e);
            var view = this;
            view.$el.slideUp();
            TagCommander.tc_ev_gl(e.currentTarget,'product_remove',{product:view.cartProduct});
            app.getCart().deleteProduct(this.id_cart_product).fail(function(){
                view.$el.slideDown();
            })
        },
        updateQuantityProduct:function(e){
            eventPreventDefaultStopPropagation(e);
            var view = this,
                currentTarget = e.currentTarget,
                cartProduct = view.cartProduct,
                newQuantity = $(currentTarget).is('.more')?1:-1;
            TagCommander.tc_ev_gl(currentTarget,'product_'+(newQuantity===-1?'remove':'add'),{product:view.cartProduct});
            if($(currentTarget).is('.more-duplicate')){
                return view.displayPageProduct(true);
            }
            view.$('.quantity-bloc button').attr('disabled',true);
            $('.circle-loader',currentTarget).addClass('playing');
            if(newQuantity===-1 && cartProduct && cartProduct.isMenu()){
                return view.deleteProduct(e);
            }
            app.getCart().updateQuantityProduct(view.id_cart_product, newQuantity);
        },
        simpleClick:function(e){
            var view = this,
                format = view.format,
                cartProduct = view.cartProduct;
            eventPreventDefaultStopPropagation(e);
            if(cartProduct.isProductLikeOffered()){
                view.updateFreeProduct();
            }else if(format === 'normal'){
                app.trigger('productLineClick',cartProduct);
            }else{
                view.displayPageProduct();
            }
        },
        displayPageProduct:function(duplicateProduct){
            var cartProduct = this.cartProduct,
                options = {
                    id_product:cartProduct.getProduct().id,
                };
            //
            if(!cartProduct && !duplicateProduct) return;
            if(!duplicateProduct){
                options.cartProduct = cartProduct
            }
            //
            app.displayModal(new ProductPageView(options));
        },
        // sidedishChange:function(e){
        //     e.preventDefault();
        //     // quand on change un accompagnement
        //     var view = this, name = e.currentTarget.name,
        //         ex = sidedishIdPattern.exec(name);
        //
        //     if(!name || !ex) return;
        //
        //     var id_sidedish = ex[2],
        //         //
        //         // TODO sur id_product
        //         // ne pas utiliser de wrapper jquery global, surtout quand on a la réference
        //         //
        //         select = view.$('select[name=' + name + ']'), id_product = select.val(), id_cart_product = ex[1],
        //         cartProduct = view.cartProduct,
        //         previousSelection;
        //     if (isNaN(parseInt(id_product))) {
        //         id_product = 0;
        //     }
        //     if (cartProduct && id_sidedish && id_cart_product) {
        //         var sidedishes = cartProduct.getSidedishes(),
        //             sidedish = sidedishes.findWhere({id_cross_selling:id_sidedish});
        //         if(sidedish){
        //             previousSelection = sidedish.get('selection')[0];
        //             if (sidedish.isRequired() && !id_product) {
        //                 select.val(previousSelection);
        //                 select.selectpicker('refresh');
        //                 app.alert(t('Vous devez sélectionner un produit', 'Product'));
        //             } else {
        //                 app.getCart().updateSidedish(id_cart_product, id_sidedish, id_product, previousSelection);
        //             }
        //         }
        //     }
        // },
        alertRequiredSidedishes:function(){
            //
            // mise en surbrillance des select
            // en webview seulement
            // pour selectionner les accompagnements obligatoires des formules
            //
            var view = this,
                cartProduct = view.cartProduct;
            if(cartProduct){
                var product = cartProduct.getProduct();
                if(product && product.isMenu()){
                    cartProduct.getSidedishes().each(function(sidedish){
                        if(sidedish.isRequired()){
                            var select = view.$('.sidedish_'+cartProduct.id+'_'+sidedish.id);
                            select.toggleClass('required',!sidedish.validateSelection());
                        }
                    });
                }
            }
        },


    });

    ProductLineView.initializeProductLinesOfView = function(view){
        var views = [];
        view.$('.product-line').each(function ()
        {
            views.push(new ProductLineView({el: this}));
        });
        return views;
    };

    return ProductLineView;
});

